import {Component, Input, OnInit} from '@angular/core';
import {ConferenceService} from '../../service/conference.service';
import {TalkJSModel} from '../../models/talkjs.model';
import Talk from 'talkjs';

@Component({
  selector: 'app-talkjs',
  templateUrl: './talkjs.component.html',
  styleUrls: ['./talkjs.component.scss'],
})
export class TalkjsComponent implements OnInit {

  @Input() taskId: number;

  talkInfo: TalkJSModel = null;

  constructor(private conferenceService: ConferenceService) { }

  ngOnInit() {
    this.conferenceService.getMyTalkJS(this.taskId)
      .then((data) => {
        if (!!data) {
          this.talkInfo = data;
          this.initTalkJS();
        }
      });
  }

  initTalkJS() {
    Talk.ready.then((): void => {
      const me = new Talk.User(this.talkInfo.user_id);
      const session = new Talk.Session({
        appId: this.talkInfo.app_id,
        me: me,
        token: this.talkInfo.user_token
      });

      const conversation = session.getOrCreateConversation(
        this.talkInfo.conversation_id
      );
      conversation.setParticipant(me);

      const chatbox = session.createChatbox();
      chatbox.select(conversation);
      chatbox.mount(document.getElementById('talkjs-container'));
    });
  }
}
